module.exports = __webpack_public_path__ + "img/file-certificate.7120c337.svg";